import React, { Component } from "react";
import theme from "../styles/theme";
import { ThemeProvider } from "@mui/styles";
import "../styles/style.css";
import { Button } from "@mui/material";
import BackButton from "@mui/icons-material/ArrowBackOutlined";
import CircularLoading from "../components/CircularLoading";
import TicketItem from "../components/TicketItem";

class Ticket extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      ticket: []
    };
  }

  componentDidMount() {
    this.getTicket();
  }

  getTicket() {
    this.setState({ loading: true });
    // TODO: Call API get ticket here
    setTimeout(() => {
      // TODO: Change this dummy data with response.
      this.setState({
        loading: false,
        ticket: [
          {
            qrCodeValue: "www.google.com",
            title: "Ticket Halal Indonesia Expo 2020",
            status: "Lunas",
            noTransaction: "2414141414",
            paid_at: "5 Maret 2020",
            owner: {
              name: "Budi",
              gender: "male",
              mobile_phone: "08423424",
              email: "afsfsf@fs.cmc"
            }
          }
        ]
      });
    }, 100);
  }

  render() {
    return (
      <ThemeProvider theme={theme}>
        <div className="header">
          <Button
            startIcon={<BackButton />}
            style={{
              position: "absolute",
              height: 60,
              width: 60,
              top: 0,
              left: 0
            }}
            onClick={() => {
              this.props.history.goBack();
            }}
          />
          <div className="center">
            <h3 className="title">Ticket</h3>
          </div>
        </div>
        <div className="wrapper" ref={el => (this.container = el)}>
          {this.state.loading ? (
            <div className="center" style={{ width: 40, height: 40 }}>
              <CircularLoading />
            </div>
          ) : (
            this.state.ticket.map(ticket => <TicketItem ticket={ticket} />)
          )}
        </div>
      </ThemeProvider>
    );
  }
}

export default Ticket;
